import gql from 'graphql-tag';

export const UPDATE_TABLE_FILTER = gql`
  mutation UpdateTableFilter($input: UpdateTableFilterInput!) {
    tableFilter {
      result: updateFilter(input: $input) {
        error
        success
      }
    }
  }
`;
